const NOTIFICATION = 'HOUSE-KEEPING/NOTIFICATION/';
export const NOTIFICATION_INIT = `${NOTIFICATION}NOTIFICATION_INIT`;
export const NOTIFICATION_DISMISS = `${NOTIFICATION}NOTIFICATION_DISMISS`;
export const HANDLE_NOTIFICATIONS = `${NOTIFICATION}HANDLE_NOTIFICATIONS`;
